import { render, staticRenderFns } from "./RelAgendaCancelados.vue?vue&type=template&id=6329d9c6"
import script from "./RelAgendaCancelados.vue?vue&type=script&lang=js"
export * from "./RelAgendaCancelados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports